import script from "./EditTrustAccountDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTrustAccountDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditTrustAccountDialog.vue?vue&type=style&index=0&id=faf91cda&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faf91cda"]])

export default __exports__